export const categories = [
  {
    id: 'latest-routes',
    name: '最新路线',
    description: '持续更新爱情岛一论坛最新免费访问路线入口，确保稳定连接不迷路',
    icon: 'ri-road-map-line',
    count: 8,
  },
  {
    id: 'access-tutorials',
    name: '访问教程',
    description: '图文并茂的访问教程，手把手教你如何快速进入爱情岛一论坛',
    icon: 'ri-book-open-line',
    count: 6,
  },
  {
    id: 'usage-tips',
    name: '使用技巧',
    description: '论坛使用高级技巧、隐藏功能挖掘，提升你的论坛使用体验',
    icon: 'ri-lightbulb-line',
    count: 5,
  },
  {
    id: 'faq',
    name: '常见问题',
    description: '汇总用户最常遇到的问题及解决方案，自助排查快速解决',
    icon: 'ri-question-answer-line',
    count: 7,
  },
];